<template>
    <div>
        <span class="btn-group btn-group-sm">
            <a class="btn" :class="hideScheduledClassName" :href="hideScheduledURL">
                <DataLabel
                    :item="$t('common.toggles.scheduled.off')"
                    :hide-icon="isShowingScheduled"
                    icon-class="fa fa-fw fa-check" />
            </a>

            <a class="btn" :class="showScheduledClassName" :href="showScheduledURL">
                <DataLabel
                    :item="$t('common.toggles.scheduled.on')"
                    :hide-icon="!isShowingScheduled"
                    icon-class="fa fa-fw fa-check" />
            </a>
        </span>
    </div>
</template>

<script>
import URI from 'urijs';

import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'ToggleScheduled',

    components: {DataLabel},

    computed: {
        isShowingScheduled() {
            return this.uri.hasQuery('scheduled', 1);
        },

        hideScheduledClassName() {
            return !this.isShowingScheduled ? ['btn-info', 'active'] : 'btn-light';
        },

        hideScheduledURL() {
            return this.uri.removeQuery(['scheduled', 'page'])
                .addQuery({'page': 1})
                .toString();
        },

        showScheduledClassName() {
            return this.isShowingScheduled ? ['btn-info', 'active'] : 'btn-light';
        },

        showScheduledURL() {
            return this.uri.removeQuery(['scheduled', 'page'])
                .addQuery({'scheduled': 1, 'page': 1})
                .toString();
        },
    },

    created() {
        this.uri = URI(window.location.href);
    },
};
</script>
